import type { RouteRecordRaw } from 'vue-router';

export default {
  meta: { feature: 'load_balancers' },
  path: 'networking/load-balancer/create',
  name: 'loadbalancer/create',
  component: () => import('@/views/dashboard/networking/loadbalancers/create.vue'),
} satisfies RouteRecordRaw;
